const headerMenus = document.querySelectorAll('.mega-menu')
headerMenus.forEach( headerMenu => {
    
  const megamenu = headerMenu.querySelector('.header-megamenu')
  megamenu.classList.remove('show');
  const link = headerMenu.querySelector('div')

  function mouseEnterHandler() {
    megamenu.classList.add('show');
  }
  
  headerMenu.addEventListener('mouseenter', mouseEnterHandler);

  headerMenu.addEventListener('mouseleave', () => {
    megamenu.classList.remove('show');
  });
  
  link.addEventListener('click', function(e) {
    e.preventDefault()

    megamenu.classList.remove('show');
    
    let targetUrl = link.dataset.url
    if (targetUrl) {
      setTimeout( () => {
        // headerMenu.removeEventListener('mouseenter', mouseEnterHandler);
        window.location.href = targetUrl
      }, 100)
    }
  })
  
})

